export default "__VITE_ASSET__BCPGvtMX__"